<template>
    <div class="w-full relative overflow-hidden p-0 m-0" :class="h">
        <div :id="'chart' + name" class="w-full relative" :class="h"></div>

        <div
            v-if="toolTip?.sum >= 0"
            class="flex flex-col justify-center items-center absolute top-0 z-40 w-20 h-8 text-xs text-center bg-cyan-600/80 rounded"
            :style="toolTip?.left"
        >
            <!-- <span class="text-white/80">{{ moment(toolTip.time).format("DD.MM") }}</span> -->
            <span class="text-sm font-bold text-white leading-4">{{ parseInt(toolTip?.sum).toLocaleString() }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { createChart } from "lightweight-charts";
import moment from "moment";

export default {
    name: "LineGraf",

    props: {
        graf: {
            type: Array,
        },
        h: {
            type: String,
            default: "h-28",
        },
        name: {
            type: String,
            default: "first",
        },
    },

    data() {
        return {
            chart: null,
            toolTip: [],
            moment: moment,
        };
    },

    computed: {
        ...mapGetters([]),
    },

    watch: {
        graf() {
            this.showGraf();
        },
    },

    methods: {
        showGraf() {
            document.getElementById("chart" + this.name).innerHTML = "";

            this.chart = createChart(document.getElementById("chart" + this.name), {
                rightPriceScale: {
                    visible: false,
                    borderVisible: false,
                },
                timeScale: {
                    borderVisible: false,
                    visible: true,
                },
                layout: {
                    background: { color: "transparent" },
                },
                grid: {
                    horzLines: {
                        color: "#eee",
                    },
                    vertLines: {
                        color: "transparent",
                    },
                },
                autoSize: true,
            });

            this.sumLine = this.chart.addAreaSeries({
                topColor: "rgba(41, 181, 204, 0.56)",
                bottomColor: "rgba(41, 181, 204, 0.04)",
                lineColor: "rgba(41, 181, 204, 1)",
                lineWidth: 2,
                lineType: 2,
                priceLineVisible: false,
                priceFormat: {
                    minMove: 1,
                    precision: 0,
                },
            });
            this.sumLine.setData(this.graf);

            this.chart.applyOptions({ autoSize: true, handleScroll: false, handleScale: false, crosshair: { mode: "Magnet" } });

            this.chart.timeScale().fitContent();

            this.chart.subscribeCrosshairMove((param) => {
                if (!param || !param.point || param.point.x < 0 || param.point.y < 0) {
                    this.toolTip.sum = -1;
                    return;
                }
                let data = param.seriesData.get(this.sumLine);
                if (data && typeof data.value === "number" && data.value >= 0) {
                    this.toolTip.sum = data.value;
                } else {
                    this.toolTip.sum = -1;
                }

                let center = this.chart.timeScale().timeToCoordinate(param.time) - 40; // 40 половина от ширины плашки (80)
                let chartWidth = document.getElementById("chart" + this.name).offsetWidth;
                if (center < 0) center = 0;
                if (center > chartWidth - 80) center = chartWidth - 80;

                this.toolTip.time = param.time;
                this.toolTip.left = { left: center + "px" };
            });
        },
    },

    mounted() {
        this.showGraf();
        window.addEventListener("resize", this.showGraf());
    },
};
</script>
